const getConsultAppointments = async ({
	leadId,
	salesforceId,
	centerId,
	startDate,
	signal,
}: {
	leadId: string;
	salesforceId?: string;
	centerId: string;
	startDate: string;
	signal: AbortSignal;
}) => {
	try {
		const queryString = `?lead_id=${leadId}&center_id=${centerId}&start_date=${startDate}&sf_id=${
			salesforceId ?? ''
		}`;
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/get-appointments/' + queryString, {
			method: 'GET',
			signal,
		});

		const result = await response.json();
		return result;
	} catch (error) {
		if (signal.aborted) {
			console.log('Fetch request aborted');
		} else if (error instanceof Error) {
			console.error(`Failed Loading Consults Appointments Data: ${error.message}`);
		}
		return [];
	}
};

export { getConsultAppointments };
